var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakingPhotos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6245 0.00716485 23.9928 5.37555 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM4.5 14.5C4.5 15.6046 5.39543 16.5 6.5 16.5H17.5C18.6046 16.5 19.5 15.6046 19.5 14.5V9.5C19.5 8.39543 18.6046 7.5 17.5 7.5H16C15.8162 7.48311 15.6419 7.41094 15.5 7.293L14.207 6C13.8778 5.69379 13.4493 5.51631 13 5.5H11C10.5507 5.51631 10.1222 5.69379 9.793 6L8.5 7.293C8.35808 7.41094 8.18375 7.48311 8 7.5H6.5C5.39543 7.5 4.5 8.39543 4.5 9.5V14.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakingPhotos);
export default __webpack_public_path__ + "static/media/takingPhotos.02d4d817.svg";
export { ForwardRef as ReactComponent };